<div class="premium-card" [class]="data?.planName.toLowerCase()"> 
  <ng-container *ngIf="data?.planName.toLowerCase() === 'bronze'; else cardContent" [ngTemplateOutlet]="borderCurrentPlan"></ng-container>
</div>
<ng-template #borderCurrentPlan>
  <div class="border-current-plan">
    <div class="card-content">
      <ng-container [ngTemplateOutlet]="cardContent"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #cardContent>
  <span *ngIf="data?.planName?.toLowerCase() === 'gold'" class="recommended">
    {{'Helps you reach your goal fastest'}}
  </span>
  <span *ngIf="data?.planName?.toLowerCase() === 'bronze'" class="current-plan-strip">
    Current Plan
  </span>
  <div class="header-section" [class]="data?.planName.toLowerCase()">
    <div class="plan-name" [class]="data?.planName.toLowerCase()">
      {{data.planName|titlecase}}
    </div>
    <div class="plan-details">
      {{data?.planDetails}}
    </div>
    <div class="plan-price" [innerHTML]="data?.planPrice">
    </div>
    <div class="plan-btn-wrapper">
      <button class="plan-btn" (click)="onPlanBtnClick()" mat-button [class]="data?.planName.toLowerCase()">
        <div class="label">
          {{data.planBtnLabel}}
        </div> 
        <mat-icon class="icon">arrow_forward</mat-icon>
      </button>
    </div>
  </div>
  <div class="divider"></div>
  <div class="included-services-wrapper">
    <div class="head">
      What's included
    </div>
    <div class="list-wrapper" [class]="data?.planName.toLowerCase()">
      <div class="list" *ngFor="let service of data?.includes">
        <div class="check">
          <img [src]="'/assets/images/ketto-premium-services/' + (service?.isChecked ? 'check': 'close') + '-icon.png'" alt="check and close icons" />
        </div>
        <div class="text" [class]="service?.isChecked ? '': 'unchecked'">
          {{service?.title}}
        </div>
      </div>
    </div>
  </div>
</ng-template>